var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeacherDashboardBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 227,
    viewBox: "0 0 650 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2924_189317)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 227,
    rx: 16,
    fill: "#FDF4C0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 647.5,
    cy: 113.5,
    r: 95.5,
    fill: "#FEE440"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 44.5,
    r: 83.5,
    fill: "#FEE440"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 35,
    r: 4,
    fill: "#FEE440"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 579,
    cy: 25,
    r: 2,
    fill: "#FEE440"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 161,
    r: 2,
    fill: "#FEE440"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 177,
    r: 2,
    fill: "#FEE440"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 608,
    cy: 209,
    r: 4,
    fill: "#FEE440"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 32,
    r: 4,
    fill: "#FEE440"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2924_189317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 227,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherDashboardBottom);
export default __webpack_public_path__ + "static/media/teacher-dashboard-bottom.24f0d2a7f99c55fa6ea67a7157dbd7d8.svg";
export { ForwardRef as ReactComponent };